module.exports = __webpack_public_path__ + "images/24f5659cd2c11c9115c48cf2b5c7f45b.png";